import React from 'react';

import _ from 'lodash';
import Lazy from 'react-lazyload';

import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';
import { Box, Card, Type } from '@nerdwallet/currency';

import { EVENT_TYPE } from '../../../lib/analytics-constants';
import ImageIcon from '../../image-icon/image-icon';

import {
  ToolLinkCard as ToolLinkCardType,
  Data,
  AnalyticsConfig,
  CalculatorType,
} from './types';
import { getLinkProps, getImpressionPayload } from './utils';

// @ts-ignore - ignore error
import styles from './tool-link-cards.module.less';

export interface ToolLinkCardProps {
  card: ToolLinkCardType;
  calculatorType?: CalculatorType;
  analyticsConfig?: AnalyticsConfig;
  impressionTrackingName: string;
  data?: Data;
  cardIndex: number;
}

const DEFAULT_IMPRESSION_PAYLOAD = { enabled: false };

const ToolLinkCard: React.FC<ToolLinkCardProps> = ({
  card,
  cardIndex,
  analyticsConfig,
  impressionTrackingName,
  calculatorType,
  data = {},
}: ToolLinkCardProps) => {
  const { header, text, img, alt, impressionEventPayload } = card;
  const link = getLinkProps(card, data);
  const snakedHeader = _.snakeCase(header);
  const { linkComponent: LinkComponent = 'a' } = link;

  const impressionPayload =
    getImpressionPayload({
      impressionEventPayload,
      analyticsConfig,
      calculatorType,
    }) ?? DEFAULT_IMPRESSION_PAYLOAD;

  return (
    <Impression {...impressionPayload} key={`${cardIndex}_${snakedHeader}`}>
      <ImpressionContext.Consumer>
        {(impressionData) => (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100"
            width={{ mobile: 80, desktop: 100 }}
            key={`${cardIndex}_${snakedHeader}`}
            className={styles.toolLinkCardsContainer}
          >
            <Impression
              eventType={EVENT_TYPE.ELEMENT_IMPRESSION}
              entityName={impressionTrackingName}
              payload={{
                element_position: cardIndex,
                section_name: analyticsConfig?.sectionName,
                section_position: analyticsConfig?.sectionPosition,
              }}
            >
              <LinkComponent
                className="tool-link-cards-card-link auth-modal-link"
                href={link.url}
                {...link.props}
                {...(typeof link.getAdditionalProps === 'function'
                  ? link.getAdditionalProps(impressionData)
                  : {})}
                impressionPayload={{ enabled: false }}
                target="_blank"
              >
                <Card {...link.props} prompt="Read more">
                  <Box align="center" paddingBottom="4">
                    <Lazy>
                      <ImageIcon src={img} alt={alt} />
                    </Lazy>
                  </Box>
                  <Box className={styles.toolLinkCardsTextContainer}>
                    <Type size="2" align="left" bold>
                      {link.text}
                    </Type>
                    <Box paddingTop="1" paddingBottom="4">
                      <Type size="1" align="left">
                        {text}
                      </Type>
                    </Box>
                  </Box>
                </Card>
              </LinkComponent>
            </Impression>
          </Box>
        )}
      </ImpressionContext.Consumer>
    </Impression>
  );
};

export default ToolLinkCard;
